import * as actionTypes from "../actions/actionTypes";

const initState = {
  loadinGetEditPost: false,
  postToEdit: null,
  error: null,
  // save Edited Post :
  loadingPutEdit: false,
  EditedPost: null,
  ErrorEditedPost: null,
};

const initGetEditPost = (state, action) => {
  return {
    ...state,
    loadinGetEditPost: action.loadinGetEditPost,
  };
};

const successGetEditPost = (state, action) => {
  return {
    ...state,
    loadinGetEditPost: action.loadinGetEditPost,
    postToEdit: action.postToEdit,
  };
};

const failGetEditPost = (state, action) => {
  return {
    ...state,
    loadinGetEditPost: action.loadinGetEditPost,
    error: action.error,
  };
};

const initPutEditPost = (state, action) => {
  return {
    ...state,
    loadingPutEdit: action.loadingPutEdit,
  };
};

const successPutEditPost = (state, action) => {
  return {
    ...state,
    loadingPutEdit: action.loadingPutEdit,
    EditedPost: action.EditedPost,
  };
};

const failPutEditPost = (state, action) => {
  return {
    ...state,
    loadingPutEdit: action.loadingPutEdit,
    ErrorEditedPost: action.ErrorEditedPost,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_GET_EDIT_POST:
      return initGetEditPost(state, action);
    case actionTypes.SUCCESS_GET_EDIT_POST:
      return successGetEditPost(state, action);
    case actionTypes.FAIL_GET_EDIT_POST:
      return failGetEditPost(state, action);
    // save Edited Post:
    case actionTypes.INIT_PUT_EDIT_POST:
      return initPutEditPost(state, action);
    case actionTypes.SUCCESS_PUT_EDIT_POST:
      return successPutEditPost(state, action);
    case actionTypes.FAIL_PUT_EDIT_POST:
      return failPutEditPost(state, action);
    default:
      return state;
  }
};

export default Reducer;
